{
    "filter_menu_title__sales_rep": "Sales Representative",
    "filter_menu_title__city": "City",
    "filter_menu_title__zip_code": "Zip Code",
    "filter_menu_title__industry": "Industry",
    "filter_menu_title__insights": "Sales Recommendations",
    "filter_menu_title__status": "Status",
    "filter_menu_title__company": "Sales Location",
    "filter_menu_title__customer_class": "Customer Type",
    "filter_menu_title__sales_region": "Sales Region",
    "filter_menu_title__customer": "Customer",
    "insight_type__cross_sell": "Cross-sell recommendations",
    "insight_type__cross_sell_never_bought": "Never bought",
    "insight_type__churn_warning": "Churn warnings",
    "insight_type__global_churn_warning": "Churn in >1 merchandise groups",
    "insight_type__first_purchase": "First purchase in merchandise group",
    "insight_type__share_of_wallet": "Share of wallet opportunities",
    "insight_type__previously_purchased": "Previously Ordered",
    "insight_type__industry_top": "Top in industry",
    "insight_type__global_top": "Top across all industries",
    "customer_search_placeholder": "Search by name, customer no., ZIP, city",
    "table_header__name": "Customer",
    "table_header__ttm_current": "Revenue 12 Months",
    "table_header__order_sum_ttm_current": "Order Sum 12 Months",
    "table_header__ttm_delta": "Delta 12 Months",
    "table_header__revenue_ytd": "Revenue YTD",
    "table_header__order_sum_ytd": "Order Sum YTD",
    "table_header__revenue_ytd_delta": "Delta YTD",
    "table_header__last_order_date": "Last order",
    "table_header__primary_rep": "Primary Rep",
    "table_header__city": "City",
    "table_header__industry": "Industry",
    "table_header__status": "Status",
    "table_header__expansion_potential": "Largest Expansion Potential",
    "table_header__revenue_decline": "Churn",
    "table_header__gm_ttm": "GM 12 Months",
    "table_header__gm_ttm_percent": "GM % 12 Months",
    "table_header__gm_ttm_delta": "Delta GM 12 Months",
    "table_header__gm_ytd": "GM YTD",
    "table_header__gm_ytd_percent": "GM % YTD",
    "table_header__gm_ytd_delta": "Delta GM YTD",
    "status_new": "New",
    "status_active": "Active",
    "status_at_risk": "At risk",
    "status_inactive": "Inactive",
    "status_blocked": "Blocked",
    "status_dormant": "Dormant",
    "status_tooltip": "Plato helps you prioritize customers. Plato derives the first four statuses from order activity and risk signals:",
    "status_tooltip_new": "just started ordering",
    "status_tooltip_active": "ordering regularly",
    "status_tooltip_at_risk": "showing churn signals",
    "status_tooltip_dormant": "no orders in 6+ months",
    "status_tooltip_inactive": "marked inactive in Plato, can be undone in Plato. No recommendations",
    "status_tooltip_blocked": "blocked in the ERP, can only be changed in the ERP. No recommendations",
    "table_footer__sum": "Sum",
    "table_header__visit_count": "Documented Visits",
    "table_header__visits_per_100k": "Visits / €100k",
    "visits_per_100k_tooltip": "Number of visits per €100k of revenue over the last 12 months. Shows whether visit effort matches customer size — useful for spotting small customers absorbing many visits and large ones being under-visited. Visits logged as “not reached” don't count. Only calculated for customers with at least €1k of revenue.",
    "table_header__last_visit": "Last Visit",
    "last_visit_tooltip": "Date of the most recent visit to this customer."
}
